import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const heroHeight = window.innerHeight * 0.85;
      const pricingEl = document.getElementById('pricing');
      let pastPricing = false;
      if (pricingEl) {
        const rect = pricingEl.getBoundingClientRect();
        pastPricing = rect.top < window.innerHeight && rect.bottom > 0;
      }
      setIsVisible(scrollY > heroHeight && !pastPricing);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-400 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0 pointer-events-none'}`} data-id="element-47">
      <div className="bg-navy-900/95 backdrop-blur-sm border-t border-navy-700 px-4 py-3" data-id="element-48">
        <div className="max-w-xl mx-auto flex items-center justify-between gap-4" data-id="element-49">
          <div className="hidden sm:flex items-center gap-3" data-id="element-50">
            <span className="text-gray-500 text-sm line-through" data-id="element-51">$29</span>
            <span className="text-white text-2xl font-bold" data-id="element-52">$6.36</span>
            <span className="bg-teal-600 text-white text-xs font-bold px-2 py-0.5 rounded-full uppercase" data-id="element-53">
              78% off
            </span>
          </div>
          <div className="sm:hidden flex items-center gap-2" data-id="element-54">
            <span className="text-white text-xl font-bold" data-id="element-55">$6.36</span>
            <span className="bg-teal-600 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-56">
              78% off
            </span>
          </div>
          <a href="https://www.betterbysteps.com/cart/44196935958621:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 text-sm sm:text-base font-bold text-white bg-amber-500 rounded-lg hover:bg-amber-600 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200 whitespace-nowrap" data-id="element-57">
            Get the Plan
            <ArrowRight className="ml-2 h-4 w-4" data-id="element-58" />
          </a>
        </div>
      </div>
    </div>;
}